import { ClientData } from "./client";
import { FileResponseData } from "./filesTypes";
import { RefundRequest } from "./RefundRequest";

export enum BookingStatus {
  Pending = 0,
  InProcess = 1,
  Canceled = 2,
  Completed = 3,
}

export interface GeideaSessionResponse {
  sessionId: string;
  
}
export type ClientNotifyRequest = {
  merchantReferenceId: string;
  orderId?: string;
  paymentStatus: "SUCCESS" | "FAILED" | "CANCELLED";
}


export type NotifyGeideaResultRequest = {
  merchantReferenceId: string;
  orderId?: string;
  paymentStatus: "SUCCESS" | "FAILED" | "CANCELLED";
};


// export enum BookingPaymentStatus {
//   Paid = 0,
//   Unpaid = 1,
// }

export interface BookingData {
  id: string;
  customerName: string;
  phone: string;
  email: string;
  address?: string | null;
  totalPrice?: string | null | undefined;
  serviceName: string;
  reason: string;
  carName?: string | null;
  createdBy?: string | null;
  updatedBy?: string | null;
  createDate?: string;
  updateDate?: string | null;
  bookingStatus?: BookingStatus;
  bookingDate?: string | null;
  isVIP?: boolean;
  bookingCode: string;
  adultsNumber: number | null;
  nationalityName: string | null;
  isGccResident?: boolean | null;
  childrenNumber: number | null;
  entryType: string | null;
  duration: string | null;
  clients: ClientData[] | null;
  refundRequests: RefundRequest[] | null;
  centerFee: string;
  partnerCenterFee: string;
  childCenterFee: string;
  partnerChildCenterFee: string;
  childPrice: string;

  processTime: string | null;
  paymentStatus?: string | null;
  refundAmount?: string;
  paymentType?: string | null;
  exception?: boolean | null;
  createdByRoles: string[];
  // ✅ ADD THESE FIELDS:
  invoiceNo?: string;
  bankCharge?: string;
  securityDeposit?: string;
  updatePaymentId?: string | null;
  servicePrice?: string;
  airportUserPrice?: string;
  airportUserChildPrice?: string;
  hasNationalityPrice?: boolean | null;
  totalCenterFee?: string;
  customSecurityDeposit?: string;
includeSecurityDeposit?: boolean | null;
createdById: string;
}

export interface BookingDetailsData {
  id: string;
  customerName: string;
  phone: string;
  email: string;
  address?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  totalPrice?: number | null | undefined;
  note?: string | null;
  serviceName: string;
  carName?: string | null;
  createdBy?: string | null;
  updatedBy?: string | null;
  createDate?: string | null;
  updateDate?: string | null;
  serviceOptionName?: string | null;
  serviceOptionFee?: number | null;
  bookingStatus?: BookingStatus;
  //bookingPaymentstatus?: BookingPaymentStatus;
  bookingDate?: Date | null;
  endBookingDate?: Date | null;
  bookingCode: string;
  paymentStatus: string | null;
  paymentType: string | null;
  fileEntities?: FileResponseData[];
  serviceId: string;
  adultsNumber: number | null;
  childrenNumber: number | null;
  exception?: boolean | null;

  entryType: string | null;
  duration: string | null;
  processTime: string | null;
  isGccResident?: boolean | null;
  reason: string;
  nationalityName: string | null;
  clients: ClientData[] | null;
  additionalPrice?: number | null | undefined;
  securityDeposit?: string;
  refundAmount?: string;
  updatePaymentId?: string | null;
  refundRequests: RefundRequest[] | null;
  servicePrice?: string;
  partnerPrice: string;
  partnerChildPrice: string;
  airportUserPrice?: string;
  airportUserChildPrice?: string;
  hasNationalityPrice?: boolean | null;
  totalCenterFee?: string;
  centerFee: string;
  partnerCenterFee: string;
  childCenterFee: string;
  partnerChildCenterFee: string;
  childPrice: string;
  customSecurityDeposit?: string;
includeSecurityDeposit?: boolean | null;
createdById: string;
}

// Define the shape of service sales
export interface ServiceSales {
  serviceName: string;
  bookingCount: number;
  totalPrice?: number | null | undefined;
  airportUserPrice?: string;
    airportUserChildPrice?: string;

   totalQty: number;
}

export interface PaymentDetails {
  transactionAmount: number;
  transactionID: string;
  createDate: string;
  currency: string;
  status: string;
  transactionStatus: string;
  orderName: string;
  merchantId: string;
}

export interface PaymentData {
  bookingId: string; // <-- make it optional
  amount: number;
  payment: PaymentDetails;
  token?: string;
  orderIds?: string;
}

export interface PartnerPaymentData {
  partnerId: string; // required for partner payments
  amount: number;
  payment: PaymentDetails;
  token?: string;
  orderIds?: string;
  paymentType?: string;
  bankCharge?: number;
}
